module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAMCAYAAACX8hZLAAAAnUlEQVQ4T73SsQkCQRCF4f+lxgYWIdiANWhkYAd2oFbgiQ0oWIFtCLbidfFk4QLBW9kdOSfeed/MMiJQtsfABZgCV0mnbzGqNWyPgAcwe+s9StrlsiLICrj1BGahCDIH7pmpe6FqJIXbPgC57/mAQkgHNcC2ZKMwUgP9hBRAjaS9bC+6m5/UnnPh+3VCnsBQQJqj/RuyBM4DbdMCmxeiJTt2foH0PgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/part3-arrow.png
// module id = Ibuu
// module chunks = 1